import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../../common/custompagination";
import Breadcrums from "../../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, showFilterListByAppointmentStatus, showFilterlistByUser } from "../../../../../utils/Constants";
import { capitalizeFirstLetter, formateDateWithMonth, handleServerValidations, TrimText , writeMyExcel } from "../../../../../utils/commonfunction";
import StatusFilter from "../../../common/statusFilter";
import { List } from "../../../services/appointment.service";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import ReportCharts from '../reportCharts'

const ServiceReportsTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Appointments", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false);
  const [filter, setFilter] = useState("30d");
  const [downloadReport, setDownloadReport] = useState(false);

  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno, statusUpdated]);

  const viewFunction = (row) => {
    navigate(`/admin/reports/service-reports/view/${row._id}`);
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

    const handleExportToExcel = () => {
        setDownloadReport(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
            .then((data) => {
                setDownloadReport(false);
                const headers = [ t('label_booking_id'), t('label_user_email'), t('label_associate_email'), 
                t('list_heading_address'), t('label_booking_date') , t('label_status') , t('label_price')];
                const rows = data.data.list.map((row) => [

                    row?.requestID ? row.requestID : "N/A",
                    row?.userData?.email ? row.userData.email : "N/A",
                    row?.associateData?.email ? row?.associateData?.email : "N/A",
                    row?.appointmentAddress ? TrimText(capitalizeFirstLetter(row.appointmentAddress.address, 30)) : "N/A",
                    row?.appointmentDate ? formateDateWithMonth(row.appointmentDate) : "N/A",
                    row?.status ? capitalizeFirstLetter(t(row?.status)) : 'N/A',
                    row?.subCategoryData?.price ? row?.subCategoryData?.price : "N/A",

                ]);

                writeMyExcel([headers, ...rows], `${t('Services Report')}.xlsx`);
            })
            .catch((error) => {
                setDownloadReport(false);
                console.log("error ====> ", error);
            });
    };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* Below section has code of charts */}
      <div className="min-h-screen w-full bg-gray-50 p-6">
        <div className="mx-auto max-w-6xl space-y-6">
            <ReportCharts filter={filter} From={ServiceReportsTable} />
            </div>
      </div>

      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Appointments</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="me-3">
                  <StatusFilter data={showFilterListByAppointmentStatus} prepareSearch={prepareSearch} />
                </div>

                <button type="reset" value="Reset" onClick={resetFilter} className="btn ripple btn-main-primary signbtn ripple">
                  {t("btn_reset_filter")}
                </button>
                <button
                    type="button"
                    onClick={() => { handleExportToExcel() }}
                    className="btn ripple btn-main-primary signbtn mr-2 ms-2"
                    disabled={downloadReport}
                >
                    {t("btn_export_report")}
                </button>
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
            <>
            <div className="table-responsive min-h-400">
              <table className="table table-bordered card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>

                    <th>
                      <span>{t("label_booking_id")}</span>
                    </th>

                    <th>{t("label_user_email")}</th>
                    <th className="">{t("label_associate_email")}</th>
                    <th>
                      <span>{t("list_heading_address")}</span>
                    </th>

                    <th className="status_head">{t("label_booking_date")}</th>
                    <th className="status_head">{t("label_status")}</th>
                    <th className="status_head">{t("label_price")}</th>

                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
               
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{row?.requestID ? <div className="d-flex">{row?.requestID ? row?.requestID : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                              <td>{row?.userData?.email ? row?.userData?.email : "N/A"}</td>
                              <td>{row?.associateData?.email ? row?.associateData?.email : "N/A"}</td>

                              <td>{row?.appointmentAddress && row?.appointmentAddress?.address ? TrimText(capitalizeFirstLetter(row?.appointmentAddress?.address, 30)) : "N/A"} </td>

                              <td>{row?.appointmentDate ? formateDateWithMonth(row.appointmentDate) : "N/A"}</td>

                              <td>{row?.status ? capitalizeFirstLetter(t(row?.status)) : "N/A"}</td>

                              <td>${row?.subCategoryData?.price ? row?.subCategoryData?.price + '.00' : "N/A"}</td>

                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button type="button" className="btn view" onClick={()=>{viewFunction(row)}}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>

                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Services Reports",
                    path: "/admin/reports/service-reports/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
            </>}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceReportsTable;
